module.exports = __webpack_public_path__ + "img/public/siteImages/user.svg?836d9bdc";